import { render } from "./password.vue?vue&type=template&id=0c2c714f&scoped=true"
import script from "./password.vue?vue&type=script&lang=ts"
export * from "./password.vue?vue&type=script&lang=ts"

import "./password.vue?vue&type=style&index=0&id=0c2c714f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c2c714f"

export default script